import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "components/Buttons/ThemeButton";
import CloseIconButton from "../../lib/CloseIconButton";
import { Typography } from "@mui/material";
import {
	bundleItem_dialogContentText_typographySxProps,
	bundleItem_dialogTitleSxProps,
	dialogActions_buttonSxProps,
	DialogTitleText,
	StyledCrownIcon
} from "../styled";
import { useState } from "react";
import { Legalese } from "../lib/Legalese_BundleItem";
import { BundleItemsGrid } from "../lib/BundleItemsGrid";
import { ILoyaltyRewardBundleItem } from "..";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";

export const BundleItem = ({
	onClose,
	onClickBuy,
	rewardItems
}: {
	onClose: () => void;
	onClickBuy: (offerId: string) => void;
	rewardItems: ILoyaltyRewardBundleItem[];
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const { dialogState } = useDialogModalRedux();
	const { offerId, itemDescription, itemPrice } = dialogState;

	const onClick = () => {
		setIsLoading(true);
		onClickBuy(offerId || "");
		setTimeout(() => {
			setIsLoading(false);
		}, 5000);
	};

	return (
		<>
			<DialogTitle sx={bundleItem_dialogTitleSxProps}>
				<CloseIconButton onClose={onClose} />
				<DialogTitleText>{itemDescription}</DialogTitleText>
				<BundleItemsGrid rewardItems={rewardItems} />
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: 0, padding: "0px 12px" }}>
				<DialogContentText sx={{ padding: ".75rem 1rem" }}>
					<Typography
						component="span"
						sx={bundleItem_dialogContentText_typographySxProps}
					>
						Confirm your purchase
					</Typography>
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center", flexDirection: "column" }}>
				<Legalese />
				{isLoading ? (
					<Button disabled sx={dialogActions_buttonSxProps}>
						processing...
					</Button>
				) : (
					<Button onClick={onClick} sx={dialogActions_buttonSxProps}>
						<Typography fontSize="24px">
							<StyledCrownIcon />
							{itemPrice?.toLocaleString("en-US")}
						</Typography>
					</Button>
				)}
			</DialogActions>
		</>
	);
};
